import { useNavigate, useParams } from '@tanstack/react-router'

import { useClientPortalEoirInternalData } from '../../hooks/use-client-portal-eoir-internal-data'

export const useClientPortalEoirInternalContent = () => {
  const navigate = useNavigate()
  const { applicantId } = useParams({
    from: '/client-portal/eoir/internal/$applicantId/$caseId',
  })

  const { dataClientPortalEoirInternal } = useClientPortalEoirInternalData()

  const caseData = dataClientPortalEoirInternal?.caseInformation
  const caseNumber = dataClientPortalEoirInternal?.caseInformation.alienNumber
  const companyData = dataClientPortalEoirInternal?.company
  const currentStatusData = dataClientPortalEoirInternal?.currentStatus
  const historyData = dataClientPortalEoirInternal?.history
  const nextHearingData = dataClientPortalEoirInternal?.nextHearing
  const courtData = dataClientPortalEoirInternal?.courtInformation
  const scheduledAlertsData = dataClientPortalEoirInternal?.alertSchedule

  const showsOtherCriticalDates = dataClientPortalEoirInternal?.portalOption?.alertSchedule

  const navigateToEoirCaseDetail = () => {
    if (!caseNumber) {
      return
    }

    void navigate({
      to: '/applicants/$applicantId/cases-eoir/$caseNumber',
      params: {
        applicantId,
        caseNumber,
      },
    })
  }

  return {
    caseData,
    companyData,
    currentStatusData,
    historyData,
    nextHearingData,
    courtData,
    scheduledAlertsData,
    showsOtherCriticalDates,
    navigateToEoirCaseDetail,
  }
}
